import {DOSSIER_TYPE} from 'front-onceforall-core/dist/utils/documents';

export function filterDocumentTypesByDossier(documentTypes, dossierType) {
  return documentTypes.filter(documentType => documentType.dossier === dossierType);
}

export function getLegalDocumentTypes(documentTypes) {
  return filterDocumentTypesByDossier(documentTypes, DOSSIER_TYPE.LEGAL);
}

export function getBusinessDocumentTypes(documentTypes) {
  return filterDocumentTypesByDossier(documentTypes, DOSSIER_TYPE.BUSINESS);
}

export function getAdditionalDocumentTypes(documentTypes) {
  return filterDocumentTypesByDossier(documentTypes, DOSSIER_TYPE.ADDITIONAL);
}

export function getProjectDocumentTypes(documentTypes) {
  return filterDocumentTypesByDossier(documentTypes, DOSSIER_TYPE.PROJECT);
}
